import { useCallback, useEffect, useState } from 'react';
import { piecesApi } from './resources';
import { surRafraichissement } from './rafraichissement';

/**
 * Les attestations de l'entreprise (RC, AVS, TVA, poursuites…) : le classeur
 * les montre, la cloche compte celles à renouveler.
 *
 * @param {boolean} actif vrai pour un compte du bureau (l'ouvrier ne les lit pas)
 * @param {number} [entrepriseId] l'entreprise ouverte
 * @returns {{pieces: object[], relit: () => void}} les pièces et leur relecture
 */
export function useAttestations(actif, entrepriseId) {
  const [pieces, setPieces] = useState([]);

  const relit = useCallback(() => {
    if (!actif || !entrepriseId) return;
    piecesApi
      .liste('ENTREPRISE', entrepriseId)
      .then((recues) => setPieces(Array.isArray(recues) ? recues : []))
      .catch(() => {});
  }, [actif, entrepriseId]);

  useEffect(() => {
    if (!actif || !entrepriseId) return undefined;
    relit();
    return surRafraichissement(relit);
  }, [actif, entrepriseId, relit]);

  return { pieces, relit };
}
